import React, { useState } from 'react'
import styled from '@emotion/styled'
import { IconMaps } from '@ow/icons'
import { fieldTypes } from '../constant'
import dittoEditor from '../ditto/register.editor'

const CreateFieldBox = styled.div`
  position: relative;

  .contain-title {
    padding: 10px 20px;
  }

  .close-field {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 20px;
    height: 64px;
    border-top: 1px solid #dcdcdc;
    width: 100%;
    cursor: pointer;

    .close-icon {
      transform: rotate(45deg);
    }
  }
`

const FieldCreateBox = styled.div`
  overflow: auto;
  padding: 10px 20px;
  .type-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .field-contain {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 5px 10px 5px 0;
    padding: 0 10px;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    width: 30%;
    max-width: 170px;
    cursor: pointer;

    &.disabled {
      border-color: #ccc;
      opacity: 0.5;
    }
    &:hover {
      border: 1px solid #0152d9;
      color: #0152d9;
    }

    .field-ico {
      padding: 5px;
    }

    .field-title {
    }
  }
`

export const FieldCreateList = ({ createFieldFilter, onCreateField }) => {
  let fieldTypesList = fieldTypes
  if (createFieldFilter) {
    fieldTypesList = fieldTypes.filter((e) =>
      createFieldFilter.includes(e.type)
    )
  }

  const [disabled, setDisabled] = useState(false)
  return (
    <FieldCreateBox>
      <div className="type-list">
        {fieldTypesList.map((field) => {
          return (
            <div
              key={field.type}
              className={`field-contain ${disabled ? 'disabled' : ''}`}
              onClick={() => {
                if (disabled) {
                  return
                }
                onCreateField({
                  ...field,
                  config: dittoEditor.config(field.type),
                })
                setDisabled(true)
                setTimeout(() => {
                  setDisabled(false)
                }, 500)
              }}
            >
              {field.icon('black')}
              <span className="field-title">{field.title}</span>
            </div>
          )
        })}
      </div>
    </FieldCreateBox>
  )
}

/**
 * 字段新建组件
 * @param {string} className 样式
 * @param {function} onCloseCreatePage 点击关闭新建字段页面时执行的函数
 * @param {function} onCreateField 点击新建字段时执行的函数
 * @returns
 */
const createField = ({
  className,
  createFieldFilter,
  onCloseCreatePage,
  onCreateField,
}) => {
  return (
    <CreateFieldBox className={className}>
      <div className="contain-title">添加表单项</div>
      <FieldCreateList
        createFieldFilter={createFieldFilter}
        onCreateField={onCreateField}
      />
      <div
        className="close-field"
        onClick={() => {
          onCloseCreatePage()
        }}
      >
        <div className="close-icon">
          <IconMaps
            type="addBoldIcon"
            width={24}
            height={24}
            fill="rgb(1, 82, 217)"
          />
        </div>
        <span>关闭</span>
      </div>
    </CreateFieldBox>
  )
}

export default createField
